exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "text-right {\n  text-align: right;\n}\n", ""]);

// exports
